import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { InquireDialog } from "./InquireDialog";
import { OfferDialog } from "./OfferDialog";
import { PurchaseDialog } from "./PurchaseDialog";
import { NoteDialog } from "./noteDialog";

export function ProcessList() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <InquireDialog />
            <OfferDialog />
            <PurchaseDialog />
            <NoteDialog />
        </>
    );
}

